import { render, staticRenderFns } from "./CaseLedger.vue?vue&type=template&id=c0cb13e0&"
import script from "./CaseLedger.vue?vue&type=script&lang=js&"
export * from "./CaseLedger.vue?vue&type=script&lang=js&"
import style0 from "./CaseLedger.vue?vue&type=style&index=0&id=c0cb13e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports